<template>
    <div class="eatSafetyStock">
        <div class="main-flex">
            <edit-btns class="btn-box" 
                :bnts="['save','output','printYuZhiDan','patchStock','refresh','goBack']"
                @saveClick="saveData()"  
                @outputClick="exportExcel()" 
                @printYuZhiDanClick="printShow=true"
                @patchStockClick="patchStockShow=true"
                @refreshClick="loadData()" 
                @goBackClick="back()"/>
            <el-switch v-model="isInputShowKeyBoard" :inline-prompt="true" active-text="启用点击即弹出数字键盘" inactive-text=""></el-switch>
        </div>
        <div class="data-box">
            <div class="flex-box">
                <div class="left-table table-box">
                    <el-tree
                        ref="treeRef"
                        class="filter-tree"
                        :data="treeData"
                        :expand-on-click-node="false"
                        node-key="id"
                        highlight-current
                        default-expand-all
                        @current-change="currentChange"
                    />
                </div>
                <div class="right-table">
                    <div class="table-box">
                        <el-table class="el-table--scrollable-y" style="width: 100%;height:100%" 
                            ref="tableEl"
                            border
                            highlight-current-row
                            @selection-change="selectFood"
                            v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}"
                            :data="pageTableData"
                        >
                            <el-table-column label="选择" type="selection" width="40" ></el-table-column>
                            <el-table-column prop="Food_Code" label="菜品编码" min-width="100" align="left"></el-table-column>
                            <el-table-column prop="Food_Name" label="菜品名称" min-width="100" align="left"></el-table-column>
                            <el-table-column prop="Food_Size" label="单位" min-width="80" align="left"></el-table-column>
                            <el-table-column prop="SubCategory_Name" label="上级分类" min-width="80" ></el-table-column>
                            <el-table-column prop="Food_Price" label="单价" min-width="80" align="right" data-format="number"></el-table-column>
                            
                            <el-table-column prop="DO_PARPRICE" label="安全库存" min-width="110" align="right" data-format="number">
                                <template #header>
                                    安全库存<span class="batch" @click="ShowKeyBoard(null,1)">[批量]</span>
                                </template>
                                <template #default="scope">
                                    <div class="num">
                                        <input-pattern class="parPrice" :data-id="scope.row.Food_ID" @click="ShowKeyBoard(scope.row,1)" 
                                            v-model="editFoodList[scope.row.Food_ID].SafetyStock" pattern="number" :min="0" :dplaces="2"
                                            @change="rowSelect(scope.row)"
                                            @keydown.enter="next('.parPrice',scope.$index+1)"
                                            @focus="$refs.tableEl?.setCurrentRow(scope.row)"
                                            @blur="editFoodList[scope.row.Food_ID].SafetyStock==''?(editFoodList[scope.row.Food_ID].SafetyStock=0):''"
                                        ></input-pattern>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="DO_PARPRICE" label="目标库存数" min-width="110" align="right" data-format="number">
                                <template #header>
                                    目标库存数<span class="batch" @click="ShowKeyBoard(null,2)">[批量]</span>
                                </template>
                                <template #default="scope">
                                    <div class="num">
                                        <input-pattern class="parPrice2" :data-id="scope.row.Food_ID" @click="ShowKeyBoard(scope.row,2)" 
                                            v-model="editFoodList[scope.row.Food_ID].TargetStock" pattern="number" :min="0" :dplaces="2"
                                            @change="rowSelect(scope.row)"
                                            @keydown.enter="next('.parPrice2',scope.$index+1)"
                                            @focus="$refs.tableEl?.setCurrentRow(scope.row)"
                                            @blur="editFoodList[scope.row.Food_ID].TargetStock==''?(editFoodList[scope.row.Food_ID].TargetStock=0):''"
                                        ></input-pattern>
                                    </div>
                                </template> 
                            </el-table-column>
                            <el-table-column prop="LastupdatedUser" label="最后更新人" min-width="100" align="left"></el-table-column> 
                            <el-table-column prop="LastupdatedTime" label="更新时间" min-width="130" :formatter="dateFormat" align="left"></el-table-column> 
                        </el-table>
                    </div>
                    <div class="search-box">
                        <key-board-input class="search"
                            type="text" v-model="searchTxt" placeholder="菜品名称、编码或助记码模糊检索"
                            isKeyEnterClose isBlurClose
                            :keyOptions="{isKeyDownEnter:true}"
                        ></key-board-input>
                        <div class="float-right">
                            <span class="last-page iconfont icon-fangxiangquan-left" @click="billPage()"></span>
                            <span class="page-number">{{ tablePageIndex+1 }}/{{ tablePageSum }}页</span>
                            <span class="next-page iconfont icon-fangxiangquan-right" @click="billPage(1)" ></span>
                            <div class="page-bnt">
                                <el-select v-model="pageSize"  >
                                    <el-option :value="20" label="20条/页"></el-option>
                                    <el-option :value="30" label="30条/页"></el-option>
                                    <el-option :value="50" label="50条/页"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <number-modal :isShow="batNumShow" :dplaces="0" type="number" :value="editFoodList[inputRow?.Food_ID]?.SafetyStock"
            title="批量修改安全库存" 
            @close="batNumShow=false" @confirm="batConfirm">
            <template #title v-if="inputRow">
                <span>安全库存-</span>{{inputRow.Food_Name}}
            </template>
        </number-modal>
        <number-modal :isShow="batNum2Show" :dplaces="0" type="number" :value="editFoodList[inputRow2?.Food_ID]?.TargetStock"
            title="批量修改目标库存数" 
            @close="batNum2Show=false" @confirm="batConfirm2">
            <template #title v-if="inputRow">
                <span>目标库存数-</span>{{inputRow.Food_Name}}
            </template>
        </number-modal>
        <!--备餐单打印分配  -->
        <modal-load :isShow="printShow" isUnload>
            <yu-zhi-print-model :isShow="printShow" @close="printShow=false"/>
        </modal-load>
        <!--自动补齐库存设置  -->
        <modal-load :isShow="patchStockShow" isUnload>
            <patch-Stock-model :isShow="patchStockShow" @close="patchStockShow=false"/>
        </modal-load>
    </div>
</template>

<script>
//菜品安全库存设置
import XLSX from 'xlsx'
import yuZhiPrintModel from './yuZhiPrintModel/yuZhiPrintModel.vue'
import patchStockModel from './patchStockModel/patchStockModel.vue'
export default {
    name:"eatSafetyStock",
    components:{
        yuZhiPrintModel,
        patchStockModel
    },
    data() {
        let pageSize= this.$cacheData.get("eatSafetyStock_pageSize")||20;
        return {
            isInputShowKeyBoard:this.$cacheData.get("eatSafetyStock_isInputShowKeyBoard")||false,
            //批量修改库存 弹层
            batNumShow:false,
            inputRow:null,
            //目标库存数 弹层
            batNum2Show:false,
            inputRow2:null,
            //补齐安全库存设置
            patchStockShow:false,
            //备餐单打印分配 弹层
            printShow:false,
            //选中的节点
            currentNode:null,
            foodMainCategory:null,
            tablePageIndex:0,
            pageSize:pageSize,
            //搜索数据
            searchTxt:"",
            //菜品库存数据
            foodSafetyList:[],
            /**勾选要修改的数据 */
            checkFoods:[],
            /**修改的数据 */
            editFoodList:{},
            batchPrice:0,
            /**高亮 */
            currentIndex:null,
            
        }
    },
    computed:{
        treeData(){
            let tree=[];
            this.foodMainCategory?.forEach(category=>{
                let children=[];
                category.FoodSubCategorys?.forEach(sub=>{
                    let posFoods=[];
                    sub.PosFoods?.forEach(food=>{
                        posFoods.push({
                            Food_ID:food.Food_ID,//菜品id
                            Food_Code:food.Food_Code,
                            Food_PinYin:food.Food_PinYin,
                            Food_Name:food.Food_Name,
                            Food_Size:food.Food_Size,
                            Food_Price:food.Food_Price,
                            SubCategory_ID:sub.SubCategory_ID,
                            SubCategory_Name:sub.SubCategory_Name
                        });
                        food.MultipleSizeFoods?.forEach(it=>{
                            posFoods.push({
                                Food_ID:it.Food_ID,//菜品id
                                Food_Code:it.Food_Code,
                                Food_PinYin:it.Food_PinYin,
                                Food_Name:it.Food_Name,
                                Food_Size:it.Food_Size,
                                Food_Price:it.Food_Price,
                                SubCategory_ID:sub.SubCategory_ID,
                                SubCategory_Name:sub.SubCategory_Name
                            });
                        })
                    })
                    children.push({
                        id:sub.SubCategory_ID,
                        label:sub.SubCategory_Code+"-"+sub.SubCategory_Name,
                        SubCategory_ID:sub.SubCategory_ID,
                        PosFoods:posFoods
                    })
                });
                if(children.length>0){
                    tree.push({
                        id:category.MainCategory_ID,
                        label:category.MainCategory_Code+"-"+category.MainCategory_Name,
                        children:children
                    });
                }
            })
            return [{label:"全部",children:tree,id:0}];
        },
        AllFoods(){
            let foods=[];
            this.treeData[0].children?.forEach(category=>{
                category.children?.forEach(sub=>{
                    sub.PosFoods?.forEach(it=>{
                        let foodSafety=this.foodSafetyList?.find(food=>food.Food_ID==it.Food_ID);
                        if(foodSafety){//库存数据
                            Object.assign(it,foodSafety);
                        }
                        foods.push(it);
                    })
                })
            })
            return foods;
        },
        tableData(){
            let posFoods=this.AllFoods;
            if(this.currentNode?.children){
                let foods=[];
                this.currentNode.children.forEach(sub=>{
                    foods=foods.concat(sub.PosFoods);
                })
                posFoods= foods;
            }else if(this.currentNode){
                posFoods=this.currentNode.PosFoods;
            }
            return posFoods;
        },
        filterData(){
            let data=this.tableData||[];
            if(this.searchTxt.trim()!=''){
                let MenuTxt=this.searchTxt.trim().toLowerCase();
                data=data.filter(t=>(t.Food_Code||"").toLowerCase().indexOf(MenuTxt)>=0 || (t.Food_Name||"").toLowerCase().indexOf(MenuTxt)>=0 || (t.Food_PinYin||"").toLowerCase().indexOf(MenuTxt)>=0);
            }
            
            return data;
        },
        /**分页数据 */
        pageTableData(){
            return this.filterData.slice(this.tablePageIndex*this.pageSize,(this.tablePageIndex+1)*this.pageSize);
        },
        tablePageSum(){
            let length=this.filterData.length;
            if(length>1){
                return Math.ceil(length/this.pageSize);
            }
            return 1;
        }
    },
    watch:{
        isInputShowKeyBoard(newVal){
            this.$cacheData.set("eatSafetyStock_isInputShowKeyBoard",newVal);
        },
        pageSize(newVal){
            this.$cacheData.set("eatSafetyStock_pageSize",newVal);
        },
        tablePageSum(newVal){
            if(newVal<=this.tablePageIndex){
                this.tablePageIndex=0;
            }
        },
        searchTxt(){
            this.tablePageIndex=0;
        },
        pageTableData:{
            handler(){
                let list={};
                this.pageTableData.forEach(it=>{
                    let json={
                        Autoid:it.Autoid,
                        Food_ID:it.Food_ID,
                        SafetyStock:it.SafetyStock||"",
                        TargetStock:it.TargetStock||""
                    }
                    list[it.Food_ID]=json;
                });
                this.editFoodList=list;
            },
            immediate:true,
        },
    },
    mounted(){
        this.$emit("navIndex",4);
        
        this.loadData();
    },
    methods:{
        back(){
            this.$router.push("setup");
        },
        async loadData(){
            const loading = this.$loading({
                text: "数据加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            
            if(!this.foodMainCategory || this.foodMainCategory.length==0){
                //获取所有菜品
                try {
                    this.foodMainCategory=await this.$cacheData.AllPosFoods();
                } catch (error) {
                    console.log('e:'+error)
                    this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
                }
            }
            let userInfo= this.$auth.getUserInfo();
            this.$httpAES.post("Bestech.CloudPos.GetFoodSafetyStock", {
                Operate_User:userInfo?.Login_Name,
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error(d.ResponseHeader.ResultDesc)
                    return;
                }else{
                    this.foodSafetyList=d.ResponseBody;
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("数据加载失败"+e.message, "提示", {confirmButtonText: "确定"});
            });
        },
        /*时间格式 */
        dateFormat(row, column, cellValue) {
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd hh:mm:ss');
        },
        currentChange(node){
            if(node.id!=0){
                this.currentNode=node;
            }else{
                this.currentNode=null;
            }
            
        },
        /**数据分页 */
        billPage(type){
            if(type==1){
                if(this.tablePageIndex+1<this.tablePageSum){
                    this.pageSave().then(()=>{
                        this.tablePageIndex++;
                    });
                    
                }else{//下一页
                    this.$message.warning('已到最后一页');
                }
            }else{//上一页
                if(this.tablePageIndex==0){
                    this.$message.warning('已到第一页');
                }
                if(this.tablePageIndex>=1){
                    this.pageSave().then(()=>{
                        this.tablePageIndex--;
                    });
                }
            }
        },
        /**翻页时提示是否先保存 */
        pageSave(){
            return new Promise((resolve,reject) => {
                if(this.checkFoods.length>0){
                    this.$confirm("当前页信息已经被修改,是否保存?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText:"取消",
                        callback: (name) => {
                            if(name=='confirm'){
                                this.saveData(()=>{
                                    resolve();
                                });
                            }else{
                                resolve();
                            }
                        },
                    });
                }else{
                    resolve();
                }
            })
        },
        //勾选的菜品
        selectFood(currentRow){
            this.checkFoods=currentRow;
        },
        /**修改时 勾选行 */
        rowSelect(row){
            this.$refs.tableEl?.toggleRowSelection(row,true);
        },
        //下一个 选中
        next(className,index){
            if(index<this.pageTableData.length){
                this.$nextTick(()=>{
                    this.$el.querySelectorAll(className+"[data-id]")[index]?.focus();
                });
            }
        },
        /**批量修改安全库存数 */
        batConfirm(newVal){
            if(this.inputRow){//单个
                this.editFoodList[this.inputRow.Food_ID].SafetyStock=newVal;
                this.rowSelect(this.inputRow);
            }else{//批量
                this.pageTableData.forEach(it=>{
                    this.editFoodList[it.Food_ID].SafetyStock=newVal;
                    this.rowSelect(it);
                });
            }
            
            this.batNumShow=false;
        },
        /**批量修改安全库存数 */
        batConfirm2(newVal){
            if(this.inputRow2){//单个
                this.editFoodList[this.inputRow2.Food_ID].TargetStock=newVal;
                this.rowSelect(this.inputRow2);
            }else{//批量
                this.pageTableData.forEach(it=>{
                    this.editFoodList[it.Food_ID].TargetStock=newVal;
                    this.rowSelect(it);
                });
            }
            
            this.batNum2Show=false;
        },
        /**显示 修改 库存 键盘 */
        ShowKeyBoard(row,type){
            if(row){
                if(this.isInputShowKeyBoard){
                    setTimeout(()=>{
                        if(type==1){
                            this.inputRow=row;
                            this.batNumShow=true;
                        }else{
                            this.inputRow2=row;
                            this.batNum2Show=true;
                        }
                    },100)
                    
                }
            }else{

                if(type==1){
                    this.inputRow=null;
                    this.batNumShow=true;
                }else{
                    this.inputRow2=null;
                    this.batNum2Show=true;
                }
                
            }
        },
        /**保存修改 
         * @param callback function 请求成功后回调
        */
        saveData(callback){
            let EatXfbmList=[];
            this.checkFoods?.forEach(it=>{
                let editInfo=this.editFoodList[it.Food_ID];
                if(editInfo){
                    EatXfbmList.push({
                        Autoid:it.Autoid,
                        Food_ID:it.Food_ID,
                        SafetyStock:editInfo.SafetyStock||0,
                        TargetStock:editInfo.TargetStock||0
                    });
                }
            })
            if(EatXfbmList.length==0){
                this.$message.warning('请勾选需要保存的数据');
                return;
            }

            const loading = this.$loading({
                text: "数据保存中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo= this.$auth.getUserInfo();
            let data={
                Operate_User:userInfo?.Login_Name,
                FoodSafetyStocks:EatXfbmList
            }
            this.$httpAES.post("Bestech.CloudPos.SetFoodSafetyStock",data).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    callback && callback();
                    this.$message.success("数据保存成功");
                    d.ResponseBody?.forEach(it=>{
                        let food=this.foodSafetyList.find(food=>food.Food_ID==it.Food_ID);
                        if(food){
                            food.SafetyStock=it.SafetyStock;
                            food.TargetStock=it.TargetStock;
                            food.LastupdatedUser=it.LastupdatedUser;
                            food.LastupdatedTime=it.LastupdatedTime;
                        }else{
                            this.foodSafetyList.push(it);
                        }
                    })
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error("数据保存失败："+e);
                console.log("数据保存失败：",e);
            })
        },
        /**Excel导出 */
        exportExcel(){ 
            if(!this.$cacheData?.globalVariable?.GlobalSysSetting.AllowUserPrintReports){
                this.$message.warning('您没有导出报表权限，请先分配权限！');
                return;
            }
            var newWorkbook = XLSX.utils.book_new();
            let turnover=[];
            turnover.push(["菜品编码","菜品名称","单位","上级分类","单价","安全库存","目标库存数","最后发布人","最后发布时间"])
            this.filterData.forEach(it=>{
                turnover.push([it.Food_Code,it.Food_Name,it.Food_Size,it.SubCategory_Name,it.Food_Price
                        ,it.SafetyStock||0,it.TargetStock||0,it.LastupdatedUser||"",this.dateFormat(null,null,it.LastupdatedTime)])
            })
            let wb = XLSX.utils.aoa_to_sheet(turnover);
            XLSX.utils.book_append_sheet(newWorkbook,wb,"菜品安全库存设置");
            XLSX.writeFile(newWorkbook,"菜品安全库存设置.xlsx")
        },
        //设置列类名
        setClassName({ row, rowIndex }){
            if(rowIndex==this.currentIndex){//高亮
                return "current-row";
            }
            return '';
        },
    }
}
</script>

<style lang="scss">
@import './eatSafetyStock.scss'
</style>